export interface IsInputEditableArgs {
  isPending: boolean
  conversationDisabled: boolean
}

export function isInputEditable({ isPending, conversationDisabled }: IsInputEditableArgs): boolean {
  return !isPending && !conversationDisabled
}
